import React, { useState, useEffect, useLayoutEffect } from 'react';
import Step1ExtMainForm from './Step1ExtMainForm';
import Step1IntMainForm from './Step1IntMainForm';
import styles from './appointment_book.module.scss';
import MobileHeightSetter from './MobileHeightSetter';

const Step1Main = props => {
  const {
    auth,
    bookFor,
    currentStep,
    isAdmin,
    isMls,
    isMobile,
    isUnverified,
    updateState,
    changeBookFor,
    isLicensed,
    isBookingVirtualTour,
    haveListingPermission,
  } = props;
  useLayoutEffect(() => {
    if (currentStep === 0 && isMobile) MobileHeightSetter('Step1Main', 0);
  }, [currentStep]);

  const [step1message, setStep1message] = useState('Your Profile');
  const [buttonsToDisplay, setButtonsToDisplay] = useState({
    'Book For Myself': false,
    'Book For Another Agent': false,
    'Agent Lookup': false,
    'Appraiser / Home Inspector': false,
  });
  useEffect(() => {
    if (bookFor === 'others') {
      setStep1message('Select Agent');
    } else if (bookFor === 'nonAgent') {
      setStep1message('Select Profile');
    } else if (bookFor === 'self') {
      setStep1message('Your Profile');
    }
  }, [bookFor]);
  useEffect(() => {
    const temp = {
      'Book For Myself': false,
      'Book For Another Agent': false,
      'Agent Lookup': false,
      'Appraiser / Home Inspector': false,
    };
    if (isBookingVirtualTour) {
      temp['Book For Another Agent'] = true;
      if (
        auth?.role &&
        isLicensed &&
        !isUnverified &&
        auth.roles[auth.role] > auth.roles.AGENT
      )
        temp['Book For Myself'] = true;
      if (!isAdmin && haveListingPermission) {
        temp['Book For Myself'] = true;
        temp['Book For Another Agent'] = true;
      }
      if (!temp['Book For Myself']) temp['Book For Another Agent'] = false;
    } else if (auth?.role) {
      if (haveListingPermission) {
        if (auth.roles[auth.role] >= auth.roles.TEAM_ADMIN) {
          temp['Agent Lookup'] = true;
          temp['Appraiser / Home Inspector'] = true;
        } else if (auth.roles[auth.role] === auth.roles.AGENT) {
          temp['Book For Myself'] = !isUnverified;
          temp['Book For Another Agent'] = true;
        }
      } else if (auth.roles[auth.role] >= auth.roles.TEAM_ADMIN && isLicensed) {
        temp['Book For Myself'] = !isUnverified;
        temp['Book For Another Agent'] = true;
      }
    }

    setButtonsToDisplay({ ...temp });
  }, [
    auth,
    haveListingPermission,
    isAdmin,
    isBookingVirtualTour,
    isLicensed,
    isUnverified,
  ]);

  return (
    <>
      {/* Step number header */}

      <div className="col-md-4">
        <hr className={`${styles.titleDivider} ${styles.titleDividerTop}`} />
        {(bookFor || isMls) && (
          <h3 className={styles.titleBlock}>
            <span className={styles.stepNumber}>Step 1 - </span>
            <span className={styles.stepTitle}>
              {isMls ? 'Your Profile' : step1message}
            </span>
          </h3>
        )}
        <hr className={`${styles.titleDivider} ${styles.titleDividerBottom}`} />

        {/* big top buttons */}
        {
          <div className="btn-group listing-edit-nav">
            {buttonsToDisplay['Book For Myself'] && (
              <label
                onClick={() => changeBookFor('self')}
                className={`btn btn-info ${bookFor === 'self' ? 'active' : ''}`}
              >
                Book For Myself
              </label>
            )}
            {buttonsToDisplay['Book For Another Agent'] && (
              <label
                onClick={() => changeBookFor('others')}
                className={`btn btn-info ${
                  bookFor === 'others' ? 'active' : ''
                }`}
                data-cy="book-for-others"
              >
                Book For Another Agent
              </label>
            )}
            {buttonsToDisplay['Agent Lookup'] && (
              <label
                onClick={() => changeBookFor('others')}
                className={`btn btn-info ${
                  bookFor === 'others' ? 'active' : ''
                }`}
              >
                Agent Lookup
              </label>
            )}
            {buttonsToDisplay['Appraiser / Home Inspector'] && (
              <label
                onClick={() => changeBookFor('nonAgent')}
                className={`btn btn-info ${
                  bookFor === 'nonAgent' ? 'active' : ''
                }`}
                data-cy="book-non-agent"
              >
                Other Profile
              </label>
            )}
          </div>
        }

        <div
          id="Step1Main"
          style={{
            paddingBottom: '0.5rem',
            minHeight: '20vh',
          }}
          className={`${styles.contentScrollableOnMobile} ${styles.flexGrow} `}
        >
          {/* show main form when booking for 'self' or external */}
          {(bookFor === 'self' || isMls) && (
            <Step1ExtMainForm updateState={updateState} {...props} />
          )}
          {/* agent/appraiser input area */}
          {bookFor !== 'self' && <Step1IntMainForm {...props} />}
        </div>
      </div>
    </>
  );
};
export default Step1Main;
